import React, { useEffect, useRef } from "react"
import { gsap } from "gsap"

const CircledButton = ({ state=`close`, className, onClick, style }) => {
  const parent = useRef()
  const verticalSvg = useRef()
  useEffect(() => {
    gsap.set(parent.current, { rotate: `${state === `close` ? 45+180 : 0}deg` })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  useEffect(() => {
    gsap.to(parent.current, { rotate: `${state === `plus` ? 0 : state === `minus` ? 180 : 45+180}deg`, duration: 0.8, ease: "expo.out" })
    gsap.to(verticalSvg.current, { rotate: `${state === `minus` ? 90 : 0}deg`, duration: 0.8, ease: "expo.out" })
  })
  return (
    <button onClick={onClick} style={{ ...style, outline: 0 }} className={`${className} rounded-full inline-flex items-center justify-center`}>
      <div className={`p-2 w-full h-full`}>
        <div ref={parent} className={`relative w-full h-full`}>
          <svg ref={verticalSvg} className={`absolute`} fill={`currentColor`} viewBox="0 0 60.9 60.9">
            <rect id="vertical" x="27.6" y="6.4" width="5.6" height="48.1"/>
          </svg>
          <svg className={`absolute`} fill={`currentColor`} viewBox="0 0 60.9 60.9">
            <rect id="horizontal" x="6.4" y="27.6" width="48.1" height="5.6"/>
          </svg>
        </div>
      </div>
    </button>
  )
}

export default CircledButton